import { useState, useEffect } from 'react';
import { api } from '../api';
import API_URL from '../api';

const NIVEL_STYLE = {
  critico: { bg: '#3a1a1a', color: '#e63946', border: '#e63946', label: '🔴 Crítico' },
  urgente: { bg: '#3a2a1a', color: '#ff9800', border: '#ff9800', label: '🟠 Urgente' },
  bajo:    { bg: '#2a2a1a', color: '#ffc107', border: '#ffc107', label: '🟡 Bajo' },
};


// ── Componente interno: detalle de un requerimiento ──────────────────────────
function ReqDetalle({ req_id }) {
  const [items,    setItems]    = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    api.get(`/requerimientos/${req_id}`)
      .then(d => setItems(d.items || []))
      .catch(() => setItems([]))
      .finally(() => setCargando(false));
  }, [req_id]);

  const URG_COLOR = { critico: '#e63946', urgente: '#ffc107', normal: '#555' };
  const URG_LABEL = { critico: '🔴 Crítico', urgente: '🟡 Urgente', normal: '⚪ Normal' };

  return (
    <div style={{ borderTop: '1px solid #2d2d44', background: '#0f0f1a', padding: '14px 16px' }}>
      {cargando ? (
        <p style={{ color: '#aaa', fontSize: 12 }}>Cargando items...</p>
      ) : items.length === 0 ? (
        <p style={{ color: '#555', fontSize: 12 }}>Sin items</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 10 }}>
          {items.map((item, i) => (
            <div key={i} style={{
              background: '#1a1a2e', borderRadius: 8, padding: '12px 14px',
              borderLeft: `3px solid ${URG_COLOR[item.urgencia] || '#555'}`,
            }}>
              <div style={{ color: '#fff', fontSize: 13, fontWeight: '600', marginBottom: 2 }}>
                {item.descripcion}
              </div>
              <div style={{ color: '#555', fontSize: 11, marginBottom: 8 }}>
                {item.codigo_bar} · {item.marca_item}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: URG_COLOR[item.urgencia], fontSize: 11 }}>
                  {URG_LABEL[item.urgencia]}
                </span>
                <span style={{ color: '#4cc9f0', fontWeight: 'bold', fontSize: 14 }}>
                  Cant. sugerida: {item.cantidad_sugerida}
                </span>
              </div>
              {item.nota_item && (
                <div style={{ color: '#888', fontSize: 11, marginTop: 6, fontStyle: 'italic' }}>
                  💬 {item.nota_item}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function Reposicion() {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [tab, setTab] = useState('alertas');
  const [busqueda, setBusqueda] = useState('');
  const [buscandoMuerto, setBuscandoMuerto] = useState(false);
  // Modal detalle
  const [productoDetalle, setProductoDetalle] = useState(null);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  const [modalAbierto, setModalAbierto] = useState(false);
  // Reposición manual
  const [marcas, setMarcas] = useState([]);
  const [marcaManual, setMarcaManual] = useState('');
  const [busquedaMarca, setBusquedaMarca] = useState('');
  const [busquedaManual, setBusquedaManual] = useState('');
  const [productosManual, setProductosManual] = useState([]);
  const [cargandoManual, setCargandoManual] = useState(false);
  const [guardandoOrden, setGuardandoOrden] = useState(false);
  const [ordenGuardada, setOrdenGuardada] = useState(null);
  const [historialOrdenes, setHistorialOrdenes] = useState([]);
  const [cargandoHistorial, setCargandoHistorial] = useState(false);
  // ── Requerimientos ──
  const [reqs,          setReqs]          = useState([]);
  const [cargandoReqs,  setCargandoReqs]  = useState(false);
  const [reqDetalle,    setReqDetalle]    = useState(null);
  const [importando,    setImportando]    = useState(null);
  const [detalleOrden, setDetalleOrden] = useState(null);
  const [cargandoDetalleOrden, setCargandoDetalleOrden] = useState(false);
  const [equivOrden, setEquivOrden] = useState(null);
  const [cargandoEquiv, setCargandoEquiv] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [itemsEditados, setItemsEditados] = useState([]);
  const [guardandoEdicion, setGuardandoEdicion] = useState(false);
  // Consolidación de órdenes
  const [seleccionadas, setSeleccionadas] = useState(new Set());
  const [proveedorConsolidado, setProveedorConsolidado] = useState('');
  const [descargandoPdf, setDescargandoPdf] = useState(false);
  // Reposición por cliente
  const [busquedaCliente, setBusquedaCliente] = useState('');
  const [resultadosCliente, setResultadosCliente] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [itemsCliente, setItemsCliente] = useState([]);
  const [cargandoCliente, setCargandoCliente] = useState(false);
  const [cargandoItemsCliente, setCargandoItemsCliente] = useState(false);
  const [cantidadesCliente, setCantidadesCliente] = useState({});

  useEffect(() => { cargar(); cargarMarcas(); }, []);

  const cargar = async (q = '') => {
    setCargando(true);
    try {
      const url = q ? `/reposicion?q=${encodeURIComponent(q)}` : '/reposicion';
      const data = await api.get(url);
      setDatos(data.error ? null : data);
    } catch (e) { console.error(e); }
    finally { setCargando(false); setBuscandoMuerto(false); }
  };

  const cargarMarcas = async () => {
    try {
      const data = await api.get('/inventario/marcas');
      setMarcas(data.marcas || []);
    } catch (e) { console.error(e); }
  };

  const buscarMuerto = () => { setBuscandoMuerto(true); cargar(busqueda); };
  const limpiarBusqueda = () => { setBusqueda(''); cargar(''); };

  const abrirDetalle = async (codigo) => {
    setModalAbierto(true);
    setCargandoDetalle(true);
    setProductoDetalle(null);
    try {
      const data = await api.get(`/inventario/producto/${codigo}`);
      setProductoDetalle(data);
    } catch (e) { console.error(e); }
    finally { setCargandoDetalle(false); }
  };

  const cerrarModal = () => { setModalAbierto(false); setProductoDetalle(null); };

  const cargarProductosMarca = async (marca) => {
    setMarcaManual(marca);
    setProductosManual([]);
    setOrdenGuardada(null);
    setCargandoManual(true);
    try {
      const data = await api.get(`/reposicion/manual?marca=${encodeURIComponent(marca)}`);
      setProductosManual((data.productos || []).map(p => ({ ...p, cantidad_pedir: '' })));
    } catch (e) { console.error(e); }
    finally { setCargandoManual(false); }
  };

  const actualizarCantidad = (idx, valor) => {
    setProductosManual(productosManual.map((p, i) => i === idx ? { ...p, cantidad_pedir: valor } : p));
  };

  const itemsConCantidad = productosManual.filter(p => p.cantidad_pedir !== '' && parseFloat(p.cantidad_pedir) > 0);

  const totalOrden = itemsConCantidad.reduce((a, p) => a + parseFloat(p.cantidad_pedir) * p.costo, 0);
  const productosManualFiltrados = productosManual
    .map((p, i) => ({ ...p, _idx: i }))  // preservar índice original para actualizarCantidad
    .filter(p =>
      p.item.toLowerCase().includes(busquedaManual.toLowerCase()) ||
      (p.codigo_bar || '').toLowerCase().includes(busquedaManual.toLowerCase()) ||
      p.codigo.toString().includes(busquedaManual)
    );
  const guardarOrden = async () => {
    if (itemsConCantidad.length === 0) { alert('Ingresa al menos una cantidad'); return; }
    setGuardandoOrden(true);
    try {
      const items = itemsConCantidad.map(p => ({
        codigo: p.codigo_bar || p.codigo,
        descripcion: p.item,
        cantidad_pedir: parseFloat(p.cantidad_pedir),
        costo_unitario: p.costo,
        valor_total: parseFloat(p.cantidad_pedir) * p.costo
      }));
      const data = await api.post('/reposicion/orden', { marca: marcaManual, items, creado_por: 'admin' });
      setOrdenGuardada(data.orden_id);
    } catch (e) { alert('Error guardando orden'); }
    finally { setGuardandoOrden(false); }
  };

  const cargarHistorialOrdenes = async () => {
    setCargandoHistorial(true);
    setSeleccionadas(new Set());
    try {
      const data = await api.get('/reposicion/ordenes');
      setHistorialOrdenes(data.ordenes || []);
    } catch (e) { console.error(e); }
    finally { setCargandoHistorial(false); }
  };

  const toggleSeleccion = (id) => {
    setSeleccionadas(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleTodas = () => {
    if (seleccionadas.size === historialOrdenes.length) {
      setSeleccionadas(new Set());
    } else {
      setSeleccionadas(new Set(historialOrdenes.map(o => o.id)));
    }
  };

  const descargarConsolidado = async () => {
    if (seleccionadas.size < 2) return;
    setDescargandoPdf(true);
    try {
      const resp = await fetch(`${API_URL}/reposicion/consolidar-pdf`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          orden_ids: Array.from(seleccionadas).sort((a,b) => a - b),
          proveedor: proveedorConsolidado.trim() || 'PROVEEDOR',
        }),
      });
      if (!resp.ok) {
        const err = await resp.json();
        alert(err.error || 'Error generando PDF');
        return;
      }
      const blob  = await resp.blob();
      const url   = URL.createObjectURL(blob);
      const link  = document.createElement('a');
      const ids   = Array.from(seleccionadas).sort((a,b) => a - b).join('_');
      link.href     = url;
      link.download = `pedido_consolidado_${ids}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      alert('Error de conexión al generar PDF');
    } finally {
      setDescargandoPdf(false);
    }
  };

  const buscarCliente = async () => {
    if (busquedaCliente.length < 3) return;
    setCargandoCliente(true);
    setResultadosCliente([]);
    try {
      const data = await api.get(`/reposicion/cliente/buscar?q=${encodeURIComponent(busquedaCliente)}`);
      setResultadosCliente(data.clientes || []);
    } catch (e) { console.error(e); }
    finally { setCargandoCliente(false); }
  };

  const seleccionarCliente = async (cliente) => {
    setClienteSeleccionado(cliente);
    setResultadosCliente([]);
    setItemsCliente([]);
    setCantidadesCliente({});
    setCargandoItemsCliente(true);
    try {
      const data = await api.get(`/reposicion/cliente/${cliente.cedula}`);
      setItemsCliente(data.items || []);
    } catch (e) { console.error(e); }
    finally { setCargandoItemsCliente(false); }
  };

  const actualizarCantidadCliente = (codigo, valor) => {
    setCantidadesCliente(prev => ({ ...prev, [codigo]: valor }));
  };

  const itemsClienteConCantidad = itemsCliente.filter(p =>
    cantidadesCliente[p.codigo] && parseFloat(cantidadesCliente[p.codigo]) > 0
  );

  const imprimirOrdenCliente = () => {
    if (itemsClienteConCantidad.length === 0) { alert('Ingresa al menos una cantidad'); return; }
    const fecha = new Date().toLocaleDateString('es-EC');
    const html = `
    <html><head><meta charset="UTF-8">
    <style>
      * { box-sizing:border-box; margin:0; padding:0; }
      body { font-family:Arial,sans-serif; padding:20px; font-size:12px; }
      .header { display:flex; justify-content:space-between; margin-bottom:20px; }
      h1 { font-size:18px; color:#1a1a2e; }
      .sub { color:#888; font-size:11px; margin-top:4px; }
      table { width:100%; border-collapse:collapse; margin-top:16px; }
      th { background:#1a1a2e; color:#fff; padding:8px 10px; font-size:11px; text-align:left; }
      td { padding:8px 10px; border-bottom:1px solid #eee; font-size:12px; }
      .firma { margin-top:40px; display:flex; justify-content:space-between; }
      .firma-line { border-top:1px solid #000; width:45%; padding-top:4px; font-size:10px; color:#888; text-align:center; }
    </style></head>
    <body>
      <div class="header">
        <div>
          <h1>🔧 TALLER ZOLER — Orden preparación cliente</h1>
          <div class="sub">Fecha: ${fecha} · Cliente: ${clienteSeleccionado.nombre} · RUC: ${clienteSeleccionado.cedula}</div>
        </div>
        <div style="text-align:right">
          <div style="font-size:10px;color:#888;">${itemsClienteConCantidad.length} productos</div>
        </div>
      </div>
      <table>
        <tr>
          <th style="width:100px">Código</th>
          <th>Descripción</th>
          <th style="width:60px;text-align:center">Unidad</th>
          <th style="width:100px;text-align:center">Cantidad</th>
        </tr>
        ${itemsClienteConCantidad.map(p => `
          <tr>
            <td style="color:#555;font-size:11px">${p.codigo_bar}</td>
            <td>${p.descripcion}</td>
            <td style="text-align:center">${p.unidad}</td>
            <td style="text-align:center;font-weight:bold;font-size:14px">${parseFloat(cantidadesCliente[p.codigo]).toFixed(0)}</td>
          </tr>`).join('')}
      </table>
      <div class="firma">
        <div class="firma-line">PREPARADO POR</div>
        <div class="firma-line">ENTREGADO A</div>
      </div>
    </body></html>`;
    const ventana = window.open('', '_blank', 'width=900,height=700');
    ventana.document.write(html);
    ventana.document.close();
    ventana.onload = () => { ventana.focus(); ventana.print(); };
  };

  const verDetalleOrden = async (id) => {
    setCargandoDetalleOrden(true);
    setDetalleOrden(null);
    setEquivOrden(null);
    try {
      const data = await api.get(`/reposicion/orden/${id}`);
      setDetalleOrden(data);
    } catch (e) { console.error(e); }
    finally { setCargandoDetalleOrden(false); }
  };

  const revisarEquivalencias = async (ordenId) => {
    setCargandoEquiv(true);
    setEquivOrden(null);
    try {
      const data = await api.get(`/reposicion/orden/${ordenId}/equivalencias`);
      setEquivOrden(data.error ? { error: data.error } : data);
    } catch (e) { setEquivOrden({ error: 'Error de conexión' }); }
    finally { setCargandoEquiv(false); }
  };

  const iniciarEdicion = () => {
    setItemsEditados(detalleOrden.items.map(i => ({ ...i })));
    setModoEdicion(true);
    setEquivOrden(null);
  };

  const cancelarEdicion = () => {
    setModoEdicion(false);
    setItemsEditados([]);
  };

  const actualizarCantidadEdicion = (idx, valor) => {
    setItemsEditados(prev => prev.map((it, i) =>
      i === idx ? { ...it, cantidad_pedir: parseFloat(valor) || 0, valor_total: (parseFloat(valor) || 0) * it.costo_unitario } : it
    ));
  };

  const eliminarItemEdicion = (idx) => {
    setItemsEditados(prev => prev.filter((_, i) => i !== idx));
  };

  const guardarEdicion = async () => {
    if (itemsEditados.length === 0) { alert('La orden debe tener al menos un producto'); return; }
    setGuardandoEdicion(true);
    try {
      const res = await api.patch(`/reposicion/orden/${detalleOrden.orden.id}`, { items: itemsEditados });
      if (res.error) { alert(res.error); return; }
      const data = await api.get(`/reposicion/orden/${detalleOrden.orden.id}`);
      setDetalleOrden(data);
      setModoEdicion(false);
      setItemsEditados([]);
      cargarHistorialOrdenes();
    } catch (e) { alert('Error guardando cambios'); }
    finally { setGuardandoEdicion(false); }
  };

  const imprimirOrdenHistorial = (orden, items) => {
    const html = `
    <html><head><meta charset="UTF-8">
    <style>
      * { box-sizing:border-box; margin:0; padding:0; }
      body { font-family:Arial,sans-serif; padding:20px; font-size:12px; }
      .header { display:flex; justify-content:space-between; margin-bottom:20px; }
      h1 { font-size:18px; color:#1a1a2e; }
      .sub { color:#888; font-size:11px; margin-top:4px; }
      table { width:100%; border-collapse:collapse; margin-top:16px; }
      th { background:#1a1a2e; color:#fff; padding:8px 10px; font-size:11px; text-align:left; }
      td { padding:8px 10px; border-bottom:1px solid #eee; font-size:12px; }
      .firma { margin-top:40px; display:flex; justify-content:space-between; }
      .firma-line { border-top:1px solid #000; width:45%; padding-top:4px; font-size:10px; color:#888; text-align:center; }
    </style></head>
    <body>
      <div class="header">
        <div>
          <h1>🔧 TALLER ZOLER — Orden a Proveedor</h1>
          <div class="sub">Fecha: ${orden.fecha} · Marca: ${orden.marca} · ${items.length} productos</div>
        </div>
        <div style="text-align:right">
          <div style="font-size:20px;font-weight:bold;color:#1a1a2e;">ORDEN #${orden.id}</div>
          <div style="font-size:10px;color:#888;">LEON FONFAY LUBRICANTES</div>
        </div>
      </div>
      <table>
        <tr>
          <th style="width:100px">Código</th>
          <th>Descripción</th>
          <th style="width:100px;text-align:center">Cantidad</th>
        </tr>
        ${items.map(i => `
          <tr>
            <td style="color:#555;font-size:11px">${i.codigo}</td>
            <td>${i.descripcion}</td>
            <td style="text-align:center;font-weight:bold;font-size:14px">${i.cantidad_pedir.toFixed(0)}</td>
          </tr>`).join('')}
      </table>
      <div class="firma">
        <div class="firma-line">AUTORIZADO POR</div>
        <div class="firma-line">RECIBIDO POR</div>
      </div>
    </body></html>`;
    const ventana = window.open('', '_blank', 'width=900,height=700');
    ventana.document.write(html);
    ventana.document.close();
    ventana.onload = () => { ventana.focus(); ventana.print(); };
  };

  const imprimirOrden = () => {
    if (itemsConCantidad.length === 0) { alert('Ingresa al menos una cantidad'); return; }
    const fecha = new Date().toLocaleDateString('es-EC');
    const html = `
    <html><head><meta charset="UTF-8">
    <style>
      * { box-sizing:border-box; margin:0; padding:0; }
      body { font-family:Arial,sans-serif; padding:20px; font-size:12px; }
      .header { display:flex; justify-content:space-between; margin-bottom:20px; }
      h1 { font-size:18px; color:#1a1a2e; }
      .sub { color:#888; font-size:11px; margin-top:4px; }
      table { width:100%; border-collapse:collapse; margin-top:16px; }
      th { background:#1a1a2e; color:#fff; padding:8px 10px; font-size:11px; text-align:left; }
      td { padding:8px 10px; border-bottom:1px solid #eee; font-size:12px; }
      .total { text-align:right; margin-top:16px; font-size:14px; font-weight:bold; color:#1a1a2e; }
      .firma { margin-top:40px; display:flex; justify-content:space-between; }
      .firma-line { border-top:1px solid #000; width:45%; padding-top:4px; font-size:10px; color:#888; text-align:center; }
    </style></head>
    <body>
      <div class="header">
        <div>
          <h1>🔧 TALLER ZOLER — Orden a Proveedor</h1>
          <div class="sub">Fecha: ${fecha} · Marca: ${marcaManual} · ${itemsConCantidad.length} productos</div>
        </div>
        <div style="text-align:right">
          <div style="font-size:20px;font-weight:bold;color:#1a1a2e;">ORDEN #${ordenGuardada || 'BORRADOR'}</div>
          <div style="font-size:10px;color:#888;">LEON FONFAY LUBRICANTES</div>
        </div>
      </div>
      <table>
        <tr>
          <th style="width:100px">Código</th>
          <th>Descripción</th>
          <th style="width:100px;text-align:center">Cantidad</th>
        </tr>
        ${itemsConCantidad.map(p => `
          <tr>
            <td style="color:#555;font-size:11px">${p.codigo_bar || p.codigo}</td>
            <td>${p.item}</td>
            <td style="text-align:center;font-weight:bold;font-size:14px">${parseFloat(p.cantidad_pedir).toFixed(0)}</td>
          </tr>`).join('')}
      </table>
      <div class="firma">
        <div class="firma-line">AUTORIZADO POR</div>
        <div class="firma-line">RECIBIDO POR</div>
      </div>
    </body></html>`;
    const ventana = window.open('', '_blank', 'width=900,height=700');
    ventana.document.write(html);
    ventana.document.close();
    ventana.onload = () => { ventana.focus(); ventana.print(); };
  };

  const marcasFiltradas = marcas.filter(m => m.toLowerCase().includes(busquedaMarca.toLowerCase()));

  const cargarRequerimientos = async () => {
    setCargandoReqs(true);
    try {
      const data = await api.get('/requerimientos?estado=pendiente');
      setReqs(data.requerimientos || []);
    } catch(e) { console.error(e); }
    finally { setCargandoReqs(false); }
  };

  const importarRequerimiento = async (req_id) => {
    setImportando(req_id);
    try {
      const res = await api.post(`/requerimientos/${req_id}/importar`, { importado_por: 'admin' });
      if (res.ok) {
        alert(`✅ Requerimiento importado como Orden #${res.orden_id}\nAhora puedes editarla en Reposición Manual.`);
        cargarRequerimientos();
      }
    } catch(e) { alert('Error al importar'); }
    finally { setImportando(null); }
  };

  if (cargando && tab !== 'manual') return <p style={s.cargando}>Analizando inventario...</p>;

  return (
    <div style={{ position: 'relative' }}>
      {/* Header */}
      <div style={s.headerRow}>
        <div>
          <h2 style={s.titulo}>🧠 Reposición Inteligente</h2>
          <p style={s.subtitulo}>Basado en promedio de ventas de los últimos 90 días</p>
        </div>
        <button style={s.botonRefresh} onClick={() => cargar('')}>🔄 Actualizar</button>
      </div>

      {/* KPIs */}
      {datos && (
        <div style={s.kpisRow}>
          <div style={{...s.kpiCard, borderTopColor: '#e63946', cursor: 'pointer'}} onClick={() => setTab('alertas')}>
            <div style={{...s.kpiValor, color: '#e63946'}}>{datos.total_critico}</div>
            <div style={s.kpiLabel}>🔴 Críticos</div>
          </div>
          <div style={{...s.kpiCard, borderTopColor: '#ff9800', cursor: 'pointer'}} onClick={() => setTab('alertas')}>
            <div style={{...s.kpiValor, color: '#ff9800'}}>{datos.total_urgente}</div>
            <div style={s.kpiLabel}>🟠 Urgentes</div>
          </div>
          <div style={{...s.kpiCard, borderTopColor: '#ffc107', cursor: 'pointer'}} onClick={() => setTab('alertas')}>
            <div style={{...s.kpiValor, color: '#ffc107'}}>{datos.total_bajo}</div>
            <div style={s.kpiLabel}>🟡 Stock bajo</div>
          </div>
          <div style={{...s.kpiCard, borderTopColor: '#9c27b0', cursor: 'pointer'}} onClick={() => setTab('muerto')}>
            <div style={{...s.kpiValor, color: '#9c27b0'}}>{datos.total_stock_muerto}</div>
            <div style={s.kpiLabel}>💀 Stock muerto</div>
          </div>
          <div style={{...s.kpiCard, borderTopColor: '#9c27b0', cursor: 'pointer'}} onClick={() => setTab('muerto')}>
            <div style={{...s.kpiValor, color: '#9c27b0', fontSize: 20}}>${datos.valor_stock_muerto.toLocaleString('es-EC', {minimumFractionDigits: 2})}</div>
            <div style={s.kpiLabel}>💰 Valor estancado</div>
          </div>
        </div>
      )}

      {/* Tabs */}
      <div style={s.tabs}>
        <button style={{...s.tab, ...(tab === 'alertas' ? s.tabActivo : {})}} onClick={() => setTab('alertas')}>
          🚨 Alertas
          {datos && datos.total_critico + datos.total_urgente + datos.total_bajo > 0 && (
            <span style={s.tabBadge}>{datos.total_critico + datos.total_urgente + datos.total_bajo}</span>
          )}
        </button>
        <button style={{...s.tab, ...(tab === 'muerto' ? {...s.tabActivo, borderBottomColor: '#9c27b0'} : {})}} onClick={() => setTab('muerto')}>
          💀 Stock Muerto
          {datos && <span style={{...s.tabBadge, background: '#9c27b0'}}>{datos.total_stock_muerto}</span>}
        </button>
        <button style={{...s.tab, ...(tab === 'manual' ? {...s.tabActivo, borderBottomColor: '#4cc9f0'} : {})}} onClick={() => setTab('manual')}>
          📋 Reposición Manual
        </button>
        <button style={{...s.tab, ...(tab === 'historial' ? {...s.tabActivo, borderBottomColor: '#4caf50'} : {})}}
          onClick={() => { setTab('historial'); cargarHistorialOrdenes(); }}>
          📦 Historial Órdenes
        </button>
        <button
          style={{...s.tab, ...(tab === 'cliente' ? {...s.tabActivo, borderBottomColor: '#f72585'} : {})}}
          onClick={() => setTab('cliente')}>
          🏢 Por Cliente
        </button>
        <button
          style={{...s.tab, ...(tab === 'requerimientos' ? {...s.tabActivo, borderBottomColor: '#a855f7'} : {})}}
          onClick={() => { setTab('requerimientos'); cargarRequerimientos(); }}>
          📋 Requerimientos
          {reqs.filter(r => r.estado === 'pendiente').length > 0 && (
            <span style={{...s.tabBadge, background: '#a855f7'}}>
              {reqs.filter(r => r.estado === 'pendiente').length}
            </span>
          )}
        </button>
      </div>

      {/* Contenido */}
      <div style={s.contenido}>

        {/* TAB ALERTAS */}
        {tab === 'alertas' && datos && (
          datos.alertas.length === 0 ? (
            <div style={s.sinAlertas}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
              <p style={{ color: '#4caf50', fontSize: 16, fontWeight: 'bold' }}>Todo el inventario está bien</p>
              <p style={{ color: '#555', fontSize: 13, marginTop: 8 }}>No hay productos que necesiten reposición en los próximos 15 días</p>
            </div>
          ) : (
            <>
              <div style={s.tabla}>
                <div style={s.tablaHeader}>
                  <span style={{ width: 90 }}>NIVEL</span>
                  <span style={{ flex: 4 }}>PRODUCTO</span>
                  <span style={{ flex: 1 }}>MARCA</span>
                  <span style={{ width: 80, textAlign: 'right' }}>STOCK</span>
                  <span style={{ width: 90, textAlign: 'right' }}>DÍAS</span>
                  <span style={{ width: 90, textAlign: 'right' }}>PEDIR</span>
                  <span style={{ width: 110, textAlign: 'right' }}>COSTO REP.</span>
                </div>
                {datos.alertas.map((a, i) => {
                  const nv = NIVEL_STYLE[a.nivel];
                  return (
                    <div key={i}
                      style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e', cursor: 'pointer'}}
                      onClick={() => abrirDetalle(a.codigo)}
                      onMouseEnter={e => e.currentTarget.style.background = '#2d2d44'}
                      onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}
                    >
                      <span style={{ width: 90 }}>
                        <span style={{ background: nv.bg, color: nv.color, border: `1px solid ${nv.border}`, borderRadius: 6, padding: '3px 6px', fontSize: 10, fontWeight: 'bold' }}>{nv.label}</span>
                      </span>
                      <span style={{ flex: 4 }}>
                        <div style={{ color: '#fff', fontSize: 13 }}>{a.item}</div>
                        <div style={{ color: '#555', fontSize: 11 }}>{a.codigo_bar} · {a.promedio_diario} uds/día</div>
                      </span>
                      <span style={{ flex: 1, color: '#aaa', fontSize: 12 }}>{a.marca}</span>
                      <span style={{ width: 80, textAlign: 'right', color: a.stock_actual <= 0 ? '#e63946' : '#fff', fontWeight: 'bold' }}>{a.stock_actual.toFixed(0)}</span>
                      <span style={{ width: 90, textAlign: 'right', color: a.dias_restantes <= 3 ? '#e63946' : a.dias_restantes <= 7 ? '#ff9800' : '#ffc107', fontWeight: 'bold' }}>
                        {a.dias_restantes === 999 ? '∞' : `${a.dias_restantes}d`}
                      </span>
                      <span style={{ width: 90, textAlign: 'right', color: '#4cc9f0', fontWeight: 'bold' }}>{a.cantidad_sugerida}</span>
                      <span style={{ width: 110, textAlign: 'right', color: '#aaa', fontSize: 13 }}>${a.costo_reposicion.toFixed(2)}</span>
                    </div>
                  );
                })}
              </div>
              <div style={s.totalRow}>
                <span style={{ color: '#aaa', fontSize: 13 }}>Costo total estimado:</span>
                <span style={{ color: '#4cc9f0', fontWeight: 'bold', fontSize: 16, marginLeft: 12 }}>
                  ${datos.alertas.reduce((a, p) => a + p.costo_reposicion, 0).toFixed(2)}
                </span>
              </div>
            </>
          )
        )}

        {/* TAB STOCK MUERTO */}
        {tab === 'muerto' && datos && (
          <>
            <div style={s.muertoInfo}>
              <span style={{ color: '#aaa', fontSize: 13 }}>
                {datos.busqueda
                  ? `Resultados para "${datos.busqueda}" — ${datos.stock_muerto.length} productos`
                  : `Top 50 por valor estancado de ${datos.total_stock_muerto} productos sin movimiento en 180 días`}
              </span>
            </div>
            <div style={s.buscadorRow}>
              <input style={s.inputBusqueda} value={busqueda} onChange={e => setBusqueda(e.target.value)}
                placeholder="Buscar por descripción o marca..." onKeyDown={e => e.key === 'Enter' && buscarMuerto()} />
              <button style={s.botonBuscar} onClick={buscarMuerto} disabled={buscandoMuerto}>
                {buscandoMuerto ? '...' : '🔍 Buscar'}
              </button>
              {datos.busqueda && <button style={s.botonLimpiar} onClick={limpiarBusqueda}>✕ Limpiar</button>}
            </div>
            <div style={s.tabla}>
              <div style={s.tablaHeader}>
                <span style={{ flex: 1 }}>CÓDIGO</span>
                <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
                <span style={{ flex: 1 }}>MARCA</span>
                <span style={{ width: 90, textAlign: 'right' }}>STOCK</span>
                <span style={{ width: 90, textAlign: 'right' }}>COSTO</span>
                <span style={{ width: 110, textAlign: 'right' }}>VALOR EST.</span>
              </div>
              {datos.stock_muerto.map((p, i) => (
                <div key={i}
                  style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e', cursor: 'pointer'}}
                  onClick={() => abrirDetalle(p.codigo)}
                  onMouseEnter={e => e.currentTarget.style.background = '#2d2d44'}
                  onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}
                >
                  <span style={{ flex: 1, color: '#555', fontSize: 11 }}>{p.codigo_bar || p.codigo}</span>
                  <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{p.item}</span>
                  <span style={{ flex: 1, color: '#aaa', fontSize: 12 }}>{p.marca}</span>
                  <span style={{ width: 90, textAlign: 'right', color: '#fff', fontWeight: 'bold' }}>{p.stock_actual.toFixed(0)}</span>
                  <span style={{ width: 90, textAlign: 'right', color: '#aaa', fontSize: 13 }}>${p.costo_unitario.toFixed(2)}</span>
                  <span style={{ width: 110, textAlign: 'right', color: '#9c27b0', fontWeight: 'bold' }}>${p.valor_estancado.toFixed(2)}</span>
                </div>
              ))}
            </div>
          </>
        )}

        {/* TAB HISTORIAL ÓRDENES */}
{tab === 'historial' && (
  <>
    {cargandoHistorial ? (
      <p style={s.cargando}>Cargando historial...</p>
    ) : (
      <>
        {/* Modal detalle orden */}
        {detalleOrden && (
          <div style={s.modalOverlay} onClick={() => setDetalleOrden(null)}>
            <div style={s.modal} onClick={e => e.stopPropagation()}>
              <div style={s.modalHeader}>
                <span style={s.modalTitulo}>
                  Orden #{detalleOrden.orden.id} — {detalleOrden.orden.marca} — {detalleOrden.orden.fecha}
                </span>
                <div style={{ display: 'flex', gap: 8 }}>
                  {!modoEdicion ? (
                    <>
                      <button
                        style={{ ...s.botonImprimir, border: '1px solid #f59e0b', color: '#f59e0b' }}
                        onClick={iniciarEdicion}>
                        ✏️ Editar
                      </button>
                      <button
                        style={{ ...s.botonImprimir, background: '#1a1a3a', border: '1px solid #a855f7', color: '#a855f7' }}
                        onClick={() => revisarEquivalencias(detalleOrden.orden.id)}
                        disabled={cargandoEquiv}>
                        {cargandoEquiv ? '⏳ Revisando...' : '🔀 Revisar equivalencias'}
                      </button>
                      <button style={s.botonImprimir}
                        onClick={() => imprimirOrdenHistorial(detalleOrden.orden, detalleOrden.items)}>
                        🖨️ Imprimir
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        style={{ ...s.botonImprimir, border: '1px solid #4caf50', color: '#4caf50', fontWeight: 'bold' }}
                        onClick={guardarEdicion}
                        disabled={guardandoEdicion}>
                        {guardandoEdicion ? '⏳ Guardando...' : '💾 Guardar cambios'}
                      </button>
                      <button style={s.botonImprimir} onClick={cancelarEdicion}>
                        Cancelar
                      </button>
                    </>
                  )}
                  <button style={s.modalCerrar} onClick={() => { setDetalleOrden(null); setEquivOrden(null); setModoEdicion(false); setItemsEditados([]); }}>✕</button>
                </div>
              </div>
              <div style={{ padding: 28, overflowY: 'auto' }}>
                <div style={s.kpisRow}>
                  <div style={s.kpiCard}>
                    <div style={s.kpiValor}>{detalleOrden.orden.total_items}</div>
                    <div style={s.kpiLabel}>Productos</div>
                  </div>
                  <div style={{...s.kpiCard, borderTopColor: '#4cc9f0'}}>
                    <div style={{...s.kpiValor, fontSize: 20}}>${detalleOrden.orden.total_valor.toFixed(2)}</div>
                    <div style={s.kpiLabel}>Valor total</div>
                  </div>
                </div>
                {modoEdicion && (
                  <div style={{ background: '#1a1200', border: '1px solid #f59e0b55', borderRadius: 8, padding: '8px 14px', marginBottom: 12, fontSize: 12, color: '#f59e0b' }}>
                    ✏️ Modo edición — modifica cantidades o elimina productos. No se pueden agregar nuevos códigos.
                  </div>
                )}
                <div style={s.tabla}>
                  <div style={s.tablaHeader}>
                    <span style={{ flex: 1 }}>CÓDIGO</span>
                    <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
                    <span style={{ width: 75, textAlign: 'right' }}>STOCK</span>
                    <span style={{ width: 85, textAlign: 'right' }}>PROM. 90d</span>
                    <span style={{ width: 90, textAlign: 'right' }}>CANTIDAD</span>
                    <span style={{ width: 90, textAlign: 'right' }}>COSTO</span>
                    <span style={{ width: 110, textAlign: 'right' }}>VALOR</span>
                    {modoEdicion && <span style={{ width: 36 }}></span>}
                  </div>
                  {(modoEdicion ? itemsEditados : detalleOrden.items).map((item, i) => (
                    <div key={i} style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}}>
                      <span style={{ flex: 1, color: '#555', fontSize: 11 }}>{item.codigo}</span>
                      <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{item.descripcion}</span>
                      <span style={{ width: 75, textAlign: 'right',
                        color: (item.stock_actual||0) > 0 ? '#4caf50' : '#555', fontSize: 12 }}>
                        {item.stock_actual != null ? item.stock_actual : '—'}
                      </span>
                      <span style={{ width: 85, textAlign: 'right' }}>
                        {item.promedio_90d > 0 ? (
                          <span style={{ color: '#4cc9f0', fontWeight: 'bold', fontSize: 13 }}>
                            {item.promedio_90d}
                            <span style={{ color: '#555', fontSize: 10, marginLeft: 2 }}>u</span>
                          </span>
                        ) : (
                          <span style={{ color: '#333', fontSize: 12 }}>—</span>
                        )}
                      </span>
                      {modoEdicion ? (
                        <div style={{ width: 90, display: 'flex', justifyContent: 'flex-end' }}>
                          <input
                            style={{ ...s.inputCantidad, width: 70, borderColor: '#f59e0b55' }}
                            type="number"
                            min="1"
                            value={item.cantidad_pedir}
                            onChange={e => actualizarCantidadEdicion(i, e.target.value)}
                          />
                        </div>
                      ) : (
                        <span style={{ width: 90, textAlign: 'right', color: '#4cc9f0', fontWeight: 'bold' }}>{item.cantidad_pedir.toFixed(0)}</span>
                      )}
                      <span style={{ width: 90, textAlign: 'right', color: '#aaa' }}>${item.costo_unitario.toFixed(2)}</span>
                      <span style={{ width: 110, textAlign: 'right', color: '#fff' }}>
                        ${modoEdicion ? (item.cantidad_pedir * item.costo_unitario).toFixed(2) : item.valor_total.toFixed(2)}
                      </span>
                      {modoEdicion && (
                        <span style={{ width: 36, textAlign: 'center' }}>
                          <button
                            onClick={() => eliminarItemEdicion(i)}
                            style={{ background: 'none', border: 'none', color: '#e63946', cursor: 'pointer', fontSize: 16, lineHeight: 1, padding: '0 4px' }}
                            title="Eliminar producto">
                            ✕
                          </button>
                        </span>
                      )}
                    </div>
                  ))}
                </div>
                {modoEdicion && (
                  <div style={{ ...s.totalRow, borderTop: '1px solid #f59e0b55' }}>
                    <span style={{ color: '#aaa', fontSize: 13 }}>Total editado ({itemsEditados.length} productos):</span>
                    <span style={{ color: '#f59e0b', fontWeight: 'bold', fontSize: 16, marginLeft: 12 }}>
                      ${itemsEditados.reduce((a, it) => a + it.cantidad_pedir * it.costo_unitario, 0).toFixed(2)}
                    </span>
                  </div>
                )}

                {/* ── Panel equivalencias ── */}
                {cargandoEquiv && (
                  <div style={{ marginTop: 24, padding: '20px', background: '#0f0f1a', borderRadius: 10, textAlign: 'center', color: '#a855f7', fontSize: 13 }}>
                    ⏳ Consultando equivalencias en Filtrocorp...
                  </div>
                )}

                {equivOrden && !cargandoEquiv && (
                  <div style={{ marginTop: 24 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
                      <span style={{ color: '#a855f7', fontWeight: 'bold', fontSize: 14 }}>🔀 Resultados de equivalencias</span>
                      <span style={{ background: '#2d2d44', color: '#aaa', borderRadius: 10, padding: '2px 8px', fontSize: 11 }}>
                        {equivOrden.items_analizados} analizados
                      </span>
                      <span style={{ background: equivOrden.items_con_stock_alt > 0 ? '#2a1a00' : '#2d2d44', color: equivOrden.items_con_stock_alt > 0 ? '#ffc107' : '#555', borderRadius: 10, padding: '2px 8px', fontSize: 11, fontWeight: 'bold' }}>
                        {equivOrden.items_con_stock_alt} con stock alternativo
                      </span>
                    </div>

                    {equivOrden.error ? (
                      <p style={{ color: '#e63946', fontSize: 13 }}>{equivOrden.error}</p>
                    ) : equivOrden.resultados?.length === 0 ? (
                      <div style={{ background: '#0f0f1a', borderRadius: 10, padding: '20px 24px', color: '#555', fontSize: 13, textAlign: 'center' }}>
                        ✅ Ningún ítem de esta orden tiene filtros equivalentes registrados
                      </div>
                    ) : (
                      equivOrden.resultados.map((r, i) => (
                        <div key={i} style={{
                          background: r.tiene_stock_alt ? '#1a1200' : '#0f0f1a',
                          border: `1px solid ${r.tiene_stock_alt ? '#ffc10755' : '#2d2d44'}`,
                          borderRadius: 10, marginBottom: 10, overflow: 'hidden',
                        }}>
                          {/* Item de la orden */}
                          <div style={{ padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10, borderBottom: '1px solid #2d2d44' }}>
                            {r.tiene_stock_alt && (
                              <span style={{ background: '#ffc107', color: '#000', borderRadius: 4, padding: '2px 7px', fontSize: 10, fontWeight: 'bold', flexShrink: 0 }}>
                                ⚠ STOCK ALT.
                              </span>
                            )}
                            <span style={{ color: '#fff', fontSize: 13, fontWeight: '600', flex: 1 }}>{r.descripcion}</span>
                            <span style={{ color: '#555', fontSize: 11, flexShrink: 0 }}>{r.barcode}</span>
                            <span style={{ color: '#4cc9f0', fontSize: 12, flexShrink: 0 }}>Pedir: {r.cantidad_pedir.toFixed(0)} uds</span>
                          </div>
                          {/* Alternativas */}
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 8, padding: '10px 14px' }}>
                            {r.alternativas.map((alt, j) => (
                              <div key={j} style={{
                                background: '#1a1a2e', borderRadius: 8, padding: '10px 12px',
                                borderLeft: `3px solid ${alt.stock > 0 ? '#4caf50' : '#2d2d44'}`,
                              }}>
                                <div style={{ color: '#fff', fontSize: 12, fontWeight: '600', marginBottom: 2 }}>
                                  {alt.item || alt.barcode}
                                </div>
                                <div style={{ color: '#555', fontSize: 10, marginBottom: 8 }}>
                                  {alt.barcode} · {alt.marca}
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                  <div>
                                    <div style={{ color: '#555', fontSize: 10 }}>Stock</div>
                                    <div style={{ color: alt.stock > 0 ? '#4caf50' : '#444', fontSize: 15, fontWeight: 'bold' }}>
                                      {alt.stock > 0 ? alt.stock : '—'}
                                    </div>
                                  </div>
                                  <div style={{ textAlign: 'right' }}>
                                    <div style={{ color: '#555', fontSize: 10 }}>Costo u.</div>
                                    <div style={{ color: '#4cc9f0', fontSize: 12 }}>
                                      {alt.costo > 0 ? `$${alt.costo.toFixed(2)}` : '—'}
                                    </div>
                                  </div>
                                  <div style={{ textAlign: 'right' }}>
                                    <div style={{ color: '#555', fontSize: 10 }}>Valor</div>
                                    <div style={{ color: '#fff', fontSize: 12 }}>
                                      {alt.valor > 0 ? `$${alt.valor.toFixed(2)}` : '—'}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ── Barra de consolidación ─────────────────────────────── */}
        {seleccionadas.size >= 2 && (
          <div style={{
            background: '#0d2218', border: '1px solid #4caf5055',
            borderRadius: 10, padding: '12px 16px', marginBottom: 14,
            display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
          }}>
            <span style={{ color: '#4caf50', fontWeight: 700, fontSize: 13 }}>
              📦 {seleccionadas.size} órdenes seleccionadas
            </span>
            <span style={{ color: '#555', fontSize: 12 }}>
              {Array.from(seleccionadas).sort((a,b)=>a-b).map(id=>`#${id}`).join(', ')}
            </span>
            <input
              value={proveedorConsolidado}
              onChange={e => setProveedorConsolidado(e.target.value)}
              placeholder="Nombre del proveedor..."
              style={{
                flex: 1, minWidth: 160,
                background: '#13131f', border: '1px solid #2a2a3e',
                borderRadius: 7, color: '#fff', padding: '7px 10px',
                fontSize: 12, outline: 'none',
              }}
            />
            <button
              onClick={descargarConsolidado}
              disabled={descargandoPdf}
              style={{
                background: descargandoPdf ? '#1a3a1a' : '#4caf50',
                border: 'none', borderRadius: 8, color: '#fff',
                padding: '8px 18px', fontSize: 13, fontWeight: 700,
                cursor: descargandoPdf ? 'not-allowed' : 'pointer',
                opacity: descargandoPdf ? 0.7 : 1,
              }}>
              {descargandoPdf ? '⏳ Generando...' : '⬇️ Descargar PDF consolidado'}
            </button>
            <button
              onClick={() => setSeleccionadas(new Set())}
              style={{
                background: 'none', border: '1px solid #2a2a3e',
                borderRadius: 7, color: '#555', padding: '7px 12px',
                fontSize: 12, cursor: 'pointer',
              }}>
              Limpiar
            </button>
          </div>
        )}

        {/* ── Tabla historial con checkboxes ─────────────────────── */}
        <div style={s.tabla}>
          <div style={{...s.tablaHeader, alignItems: 'center'}}>
            <span style={{ width: 36 }}>
              <input type="checkbox"
                checked={historialOrdenes.length > 0 && seleccionadas.size === historialOrdenes.length}
                onChange={toggleTodas}
                style={{ cursor: 'pointer', accentColor: '#4caf50' }}
              />
            </span>
            <span style={{ width: 60 }}>#</span>
            <span style={{ flex: 1 }}>Fecha</span>
            <span style={{ flex: 1 }}>Marca</span>
            <span style={{ width: 80, textAlign: 'center' }}>Items</span>
            <span style={{ width: 120, textAlign: 'right' }}>Valor total</span>
            <span style={{ width: 100, textAlign: 'center' }}>Acción</span>
          </div>
          {historialOrdenes.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#555' }}>
              No hay órdenes registradas
            </div>
          ) : historialOrdenes.map((o, i) => {
            const checked = seleccionadas.has(o.id);
            return (
              <div key={o.id} style={{
                ...s.tablaRow,
                background: checked
                  ? '#0d2218'
                  : i % 2 === 0 ? '#1e1e2e' : '#1a1a2e',
                borderLeft: checked ? '3px solid #4caf50' : '3px solid transparent',
              }}>
                <span style={{ width: 36 }}>
                  <input type="checkbox"
                    checked={checked}
                    onChange={() => toggleSeleccion(o.id)}
                    style={{ cursor: 'pointer', accentColor: '#4caf50' }}
                  />
                </span>
                <span style={{ width: 60, color: '#4cc9f0', fontWeight: 'bold' }}>#{o.id}</span>
                <span style={{ flex: 1, color: '#fff', fontSize: 13 }}>{o.fecha}</span>
                <span style={{ flex: 1, color: '#aaa', fontSize: 13 }}>{o.marca}</span>
                <span style={{ width: 80, textAlign: 'center', color: '#fff' }}>{o.total_items}</span>
                <span style={{ width: 120, textAlign: 'right', color: '#4cc9f0', fontWeight: 'bold' }}>
                  ${o.total_valor.toFixed(2)}
                </span>
                <span style={{ width: 100, textAlign: 'center' }}>
                  <button style={s.botonVer} onClick={() => verDetalleOrden(o.id)}>
                    {cargandoDetalleOrden ? '...' : 'Ver →'}
                  </button>
                </span>
              </div>
            );
          })}
        </div>

        {seleccionadas.size === 1 && (
          <div style={{ color: '#555', fontSize: 12, textAlign: 'center', marginTop: 10 }}>
            Selecciona al menos 2 órdenes para consolidar
          </div>
        )}
      </>
    )}
  </>
)}

        {/* TAB REPOSICIÓN MANUAL */}
        {tab === 'manual' && (
          <div style={s.manualContainer}>
            {/* Sidebar marcas */}
            <div style={s.manualSidebar}>
              <div style={s.sidebarTitulo}>🏷️ Selecciona marca</div>
              <input style={s.searchMarca} value={busquedaMarca} onChange={e => setBusquedaMarca(e.target.value)} placeholder="Buscar marca..." />
              <div style={s.marcasList}>
                {marcasFiltradas.map(m => (
                  <div key={m}
                    style={{...s.marcaItem, ...(marcaManual === m ? s.marcaItemActivo : {})}}
                    onClick={() => cargarProductosMarca(m)}>
                    {m}
                  </div>
                ))}
              </div>
            </div>

            {/* Tabla productos */}
            <div style={s.manualMain}>
              {!marcaManual ? (
                <div style={s.sinAlertas}>
                  <div style={{ fontSize: 48, marginBottom: 16 }}>🏷️</div>
                  <p style={{ color: '#aaa', fontSize: 15 }}>Selecciona una marca para comenzar</p>
                </div>
              ) : cargandoManual ? (
                <p style={s.cargando}>Cargando productos de {marcaManual}...</p>
              ) : (
                                 
                <>
                  {/* Header con acciones */}
                  <div style={s.manualHeader}>
                    <div>
                      <span style={{ color: '#fff', fontWeight: 'bold', fontSize: 15 }}>🏷️ {marcaManual}</span>
                      <span style={{ color: '#555', fontSize: 13, marginLeft: 12 }}>{productosManual.length} productos</span>
                      {itemsConCantidad.length > 0 && (
                        <span style={{ color: '#4cc9f0', fontSize: 13, marginLeft: 12 }}>
                          · {itemsConCantidad.length} seleccionados · ${totalOrden.toFixed(2)}
                        </span>
                      )}
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button style={s.botonImprimir} onClick={imprimirOrden} disabled={itemsConCantidad.length === 0}>
                        🖨️ Imprimir orden
                      </button>
                      <button
                        style={{...s.botonGuardar, ...(ordenGuardada ? { background: '#2e7d32' } : {})}}
                        onClick={guardarOrden}
                        disabled={guardandoOrden || !!ordenGuardada || itemsConCantidad.length === 0}
                      >
                        {guardandoOrden ? 'Guardando...' : ordenGuardada ? `✅ Guardada #${ordenGuardada}` : '💾 Guardar orden'}
                      </button>
                    </div>
                  </div>

                  {/* ← BARRA DE BÚSQUEDA NUEVA */}
                  <input
                    style={s.searchProducto}
                    value={busquedaManual}
                    onChange={e => setBusquedaManual(e.target.value)}
                    placeholder="Buscar por código o descripción..."
                  />

                  {/* Tabla — usar productosManualFiltrados y _idx */}
                  <div style={s.tabla}>
                    <div style={s.tablaHeader}>
                      <span style={{ flex: 1, fontSize: 10 }}>CÓDIGO</span>
                      <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
                      <span style={{ width: 70, textAlign: 'right' }}>STOCK</span>
                      <span style={{ width: 80, textAlign: 'right' }}>PROM. 90d</span>
                      <span style={{ width: 100, textAlign: 'center' }}>A PEDIR</span>
                      <span style={{ width: 80, textAlign: 'right' }}>COSTO</span>
                      <span style={{ width: 110, textAlign: 'right' }}>VALOR REP.</span>
                    </div>
                    {productosManualFiltrados.map((p, i) => {
                      const cant = parseFloat(p.cantidad_pedir) || 0;
                      const valorRep = cant * p.costo;
                      return (
                        <div key={p._idx} style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e', ...(cant > 0 ? { borderLeft: '3px solid #4cc9f0' } : {})}}>
                          <span style={{ flex: 1, color: '#fff', fontSize: 11 }}>{p.codigo_bar || p.codigo}</span>
                          <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{p.item}</span>
                          <span style={{ width: 70, textAlign: 'right', color: p.stock <= 0 ? '#e63946' : '#aaa' }}>{p.stock.toFixed(0)}</span>
                          <span style={{ width: 80, textAlign: 'right', color: '#4cc9f0', fontSize: 12 }}>{p.promedio_90.toFixed(0)}</span>
                          <div style={{ width: 100, display: 'flex', justifyContent: 'center' }}>
                            <input
                              style={{...s.inputCantidad, ...(cant > 0 ? { borderColor: '#4cc9f0' } : {})}}
                              type="number"
                              min="0"
                              value={p.cantidad_pedir}
                              onChange={e => actualizarCantidad(p._idx, e.target.value)}  // ← _idx
                              placeholder="0"
                            />
                          </div>
                          <span style={{ width: 80, textAlign: 'right', color: '#aaa', fontSize: 12 }}>${p.costo.toFixed(2)}</span>
                          <span style={{ width: 110, textAlign: 'right', color: cant > 0 ? '#4cc9f0' : '#333', fontWeight: cant > 0 ? 'bold' : 'normal', fontSize: 13 }}>
                            {cant > 0 ? `$${valorRep.toFixed(2)}` : '—'}
                          </span>
                        </div>
                      );
                    })}
                  </div>

                  {itemsConCantidad.length > 0 && (
                    <div style={s.totalRow}>
                      <span style={{ color: '#aaa', fontSize: 13 }}>Total orden ({itemsConCantidad.length} productos):</span>
                      <span style={{ color: '#4cc9f0', fontWeight: 'bold', fontSize: 18, marginLeft: 12 }}>${totalOrden.toFixed(2)}</span>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}

        {/* TAB REQUERIMIENTOS DE TÉCNICOS */}
        {tab === 'requerimientos' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div>
                <h3 style={{ color: '#fff', margin: 0 }}>📋 Requerimientos de Técnicos</h3>
                <p style={{ color: '#555', fontSize: 12, marginTop: 4 }}>
                  Solicitudes pendientes de revisión · Importa para generar orden de compra
                </p>
              </div>
              <button
                style={{ background: 'none', border: '1px solid #2d2d44', borderRadius: 8,
                  color: '#aaa', padding: '8px 16px', cursor: 'pointer', fontSize: 13 }}
                onClick={cargarRequerimientos}>
                🔄 Actualizar
              </button>
            </div>

            {cargandoReqs ? (
              <p style={{ color: '#aaa', textAlign: 'center', padding: 40 }}>Cargando requerimientos...</p>
            ) : reqs.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 60, color: '#555' }}>
                <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
                <div>Sin requerimientos pendientes</div>
              </div>
            ) : (
              reqs.map((r) => {
                const abierto = reqDetalle === r.id;
                return (
                  <div key={r.id} style={{
                    background: '#1a1a2e', borderRadius: 12, marginBottom: 10,
                    border: abierto ? '1px solid #a855f7' : '1px solid #2d2d44', overflow: 'hidden',
                  }}>
                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px', cursor: 'pointer' }}
                      onClick={() => setReqDetalle(abierto ? null : r.id)}>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                          <span style={{ color: '#a855f7', fontWeight: 'bold', fontSize: 13 }}>#{r.id}</span>
                          <span style={{ color: '#fff', fontSize: 13, fontWeight: '600' }}>
                            {r.tecnico}
                          </span>
                          {r.marca && <span style={{ color: '#555', fontSize: 11 }}>· {r.marca}</span>}
                          <span style={{ color: '#555', fontSize: 11 }}>· {r.created_at}</span>
                        </div>
                        <div style={{ display: 'flex', gap: 8 }}>
                          {r.criticos > 0 && (
                            <span style={{ background: '#e6394622', color: '#e63946',
                              borderRadius: 6, padding: '2px 8px', fontSize: 11 }}>
                              🔴 {r.criticos} crítico(s)
                            </span>
                          )}
                          {r.urgentes > 0 && (
                            <span style={{ background: '#ffc10722', color: '#ffc107',
                              borderRadius: 6, padding: '2px 8px', fontSize: 11 }}>
                              🟡 {r.urgentes} urgente(s)
                            </span>
                          )}
                          <span style={{ color: '#555', fontSize: 11 }}>{r.total_items} ítem(s)</span>
                        </div>
                      </div>
                      <button
                        style={{
                          background: importando === r.id ? '#555' : '#a855f7',
                          border: 'none', borderRadius: 8, color: '#fff',
                          padding: '10px 20px', cursor: importando === r.id ? 'not-allowed' : 'pointer',
                          fontSize: 13, fontWeight: 'bold', whiteSpace: 'nowrap',
                        }}
                        disabled={importando === r.id}
                        onClick={(e) => { e.stopPropagation(); importarRequerimiento(r.id); }}>
                        {importando === r.id ? 'Importando...' : '📥 Importar → Orden'}
                      </button>
                      <span style={{ color: '#555', fontSize: 14 }}>{abierto ? '▲' : '▼'}</span>
                    </div>

                    {/* Detalle expandido — carga items desde API */}
                    {abierto && (
                      <ReqDetalle req_id={r.id} />
                    )}
                  </div>
                );
              })
            )}
          </div>
        )}

        {/* TAB REPOSICIÓN POR CLIENTE */}
        {tab === 'cliente' && (
        <div>
          {/* Buscador */}
          <div style={s.buscadorRow}>
            <input
              style={s.inputBusqueda}
              value={busquedaCliente}
              onChange={e => setBusquedaCliente(e.target.value)}
              placeholder="Buscar por RUC o nombre del cliente..."
              onKeyDown={e => e.key === 'Enter' && buscarCliente()}
            />
            <button style={s.botonBuscar} onClick={buscarCliente} disabled={cargandoCliente}>
              {cargandoCliente ? '...' : '🔍 Buscar'}
            </button>
            {clienteSeleccionado && (
              <button style={s.botonLimpiar} onClick={() => {
                setClienteSeleccionado(null);
                setItemsCliente([]);
                setBusquedaCliente('');
                setCantidadesCliente({});
              }}>✕ Limpiar</button>
            )}
          </div>

          {/* Resultados búsqueda */}
          {resultadosCliente.length > 0 && (
            <div style={s.resultadosCliente}>
              {resultadosCliente.map((c, i) => (
                <div key={i} style={s.resultadoItem} onClick={() => seleccionarCliente(c)}
                  onMouseEnter={e => e.currentTarget.style.background = '#2d2d44'}
                  onMouseLeave={e => e.currentTarget.style.background = '#1a1a2e'}>
                  <span style={{ color: '#fff', fontWeight: 'bold' }}>{c.nombre}</span>
                  <span style={{ color: '#555', fontSize: 12, marginLeft: 12 }}>{c.cedula}</span>
                  <span style={{ color: '#aaa', fontSize: 12, marginLeft: 12 }}>{c.telefono}</span>
                </div>
              ))}
            </div>
          )}

          {/* Cliente seleccionado */}
          {clienteSeleccionado && (
            <>
              <div style={s.clienteHeader}>
                <div>
                  <span style={{ color: '#fff', fontWeight: 'bold', fontSize: 15 }}>🏢 {clienteSeleccionado.nombre}</span>
                  <span style={{ color: '#555', fontSize: 13, marginLeft: 12 }}>RUC: {clienteSeleccionado.cedula}</span>
                  {clienteSeleccionado.telefono && (
                    <span style={{ color: '#555', fontSize: 13, marginLeft: 12 }}>📞 {clienteSeleccionado.telefono}</span>
                  )}
                </div>
                {itemsClienteConCantidad.length > 0 && (
                  <button style={s.botonImprimir} onClick={imprimirOrdenCliente}>
                    🖨️ Imprimir orden ({itemsClienteConCantidad.length} items)
                  </button>
                )}
              </div>

              {cargandoItemsCliente ? (
                <p style={{...s.cargando, marginTop: 40}}>Analizando historial del cliente... (puede tomar unos segundos)</p>
              ) : itemsCliente.length === 0 ? (
                <p style={{ color: '#555', textAlign: 'center', marginTop: 40 }}>Sin productos con patrón de compra identificado</p>
              ) : (
                <>
                  <p style={{ color: '#555', fontSize: 12, marginBottom: 12 }}>
                    {itemsCliente.length} productos con 2+ compras en los últimos 9 meses · ingresa cantidad a pedir para incluir en la orden
                  </p>
                  <div style={s.tabla}>
                    <div style={s.tablaHeader}>
                      <span style={{ flex: 1, fontSize: 10 }}>CÓDIGO</span>
                      <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
                      <span style={{ width: 60, textAlign: 'center' }}>UNIT.</span>
                      <span style={{ width: 70, textAlign: 'right' }}>STOCK</span>
                      <span style={{ width: 80, textAlign: 'center' }}>COMPRAS</span>
                      <span style={{ width: 90, textAlign: 'center' }}>CANT. PROM.</span>
                      <span style={{ width: 100, textAlign: 'center' }}>INTERVALO</span>
                      <span style={{ width: 110, textAlign: 'center' }}>PRÓXIMA</span>
                      <span style={{ width: 90, textAlign: 'center' }}>A PEDIR</span>
                    </div>
                    {itemsCliente.map((p, i) => {
                      const estadoStyle = {
                        vencido: { bg: '#3a1a1a', color: '#e63946' },
                        proximo: { bg: '#3a2a1a', color: '#ff9800' },
                        ok:      { bg: '#1a2a1a', color: '#4caf50' },
                        unico:   { bg: '#2a2a2a', color: '#555' },
                      }[p.estado];
                      const cant = cantidadesCliente[p.codigo] || '';
                      return (
                        <div key={i} style={{
                          ...s.tablaRow,
                          background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e',
                          ...(parseFloat(cant) > 0 ? { borderLeft: '3px solid #f72585' } : {})
                        }}>
                          <span style={{ flex: 1, color: '#fff', fontSize: 10 }}>{p.codigo_bar || p.codigo}</span>
                          <span style={{ flex: 4, color: '#fff', fontSize: 12 }}>{p.descripcion}</span>
                          <span style={{ width: 60, textAlign: 'center', color: '#aaa', fontSize: 11 }}>{p.unidad}</span>
                          <span style={{ width: 70, textAlign: 'right', color: p.stock_actual <= 0 ? '#e63946' : '#aaa' }}>
                            {p.stock_actual.toFixed(0)}
                          </span>
                          <span style={{ width: 80, textAlign: 'center', color: '#4cc9f0', fontWeight: 'bold' }}>{p.total_compras}x</span>
                          <span style={{ width: 90, textAlign: 'center', color: '#aaa' }}>{p.cantidad_promedio} {p.unidad}</span>
                          <span style={{ width: 100, textAlign: 'center', color: '#aaa', fontSize: 11 }}>
                            {p.intervalo_promedio > 0 ? `c/${p.intervalo_promedio}d` : '—'}
                          </span>
                          <span style={{ width: 110, textAlign: 'center' }}>
                            <span style={{ background: estadoStyle.bg, color: estadoStyle.color, borderRadius: 6, padding: '3px 8px', fontSize: 11, fontWeight: 'bold' }}>
                              {p.mensaje}
                            </span>
                          </span>
                          <div style={{ width: 90, display: 'flex', justifyContent: 'center' }}>
                            <input
                              style={{...s.inputCantidad, ...(parseFloat(cant) > 0 ? { borderColor: '#f72585' } : {})}}
                              type="number"
                              min="0"
                              value={cant}
                              onChange={e => actualizarCantidadCliente(p.codigo, e.target.value)}
                              placeholder="0"
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      )}

      </div>

      {/* Modal detalle producto */}
      {modalAbierto && (
        <div style={s.modalOverlay} onClick={cerrarModal}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <span style={s.modalTitulo}>{productoDetalle?.ultima_compra?.producto || 'Detalle del producto'}</span>
              <button style={s.modalCerrar} onClick={cerrarModal}>✕</button>
            </div>
            {cargandoDetalle ? (
              <p style={{...s.cargando, padding: 60}}>Cargando detalle...</p>
            ) : productoDetalle?.error ? (
              <p style={{ color: '#e63946', padding: 28 }}>{productoDetalle.error}</p>
            ) : productoDetalle ? (
              <>
                <div style={s.filaCompra}>
                  <div style={s.filaCompraInner}>
                    <div style={s.compraGrid}>
                      {[
                        ['Fecha', productoDetalle.ultima_compra.fecha],
                        ['Proveedor', productoDetalle.ultima_compra.proveedor],
                        ['RUC', productoDetalle.ultima_compra.ruc_proveedor],
                        ['Factura', productoDetalle.ultima_compra.factura],
                        ['Forma de pago', productoDetalle.ultima_compra.forma_pago],
                        ['Cantidad comprada', `${productoDetalle.ultima_compra.cantidad_comprada.toFixed(0)} ${productoDetalle.ultima_compra.unidad}`],
                        ['Costo unitario', `$${productoDetalle.ultima_compra.costo.toFixed(2)}`],
                        ['IVA', `${productoDetalle.ultima_compra.iva_pct}%`],
                        ['PVP', `$${productoDetalle.ultima_compra.pvp.toFixed(2)}`],
                      ].map(([label, valor]) => (
                        <div key={label} style={s.compraItem}>
                          <span style={s.compraLabel}>{label}</span>
                          <span style={{...s.compraValor, ...(label === 'PVP' ? {color: '#4cc9f0', fontWeight: 'bold'} : {})}}>{valor}</span>
                        </div>
                      ))}
                    </div>
                    <div style={s.stockWrap}>
                      <div style={s.seccionTitulo}>📦 STOCK</div>
                      <div style={s.stockRow}>
                        <div style={s.stockCard}>
                          <div style={s.stockNum}>{productoDetalle.ultima_compra.stock_anterior.toFixed(0)}</div>
                          <div style={s.stockLabel}>Antes de compra</div>
                        </div>
                        <div style={s.stockArrow}>→</div>
                        <div style={{...s.stockCard, borderColor: '#4cc9f0'}}>
                          <div style={{...s.stockNum, color: '#4cc9f0'}}>{productoDetalle.ultima_compra.stock_actual.toFixed(0)}</div>
                          <div style={s.stockLabel}>Stock actual</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={s.filaVentas}>
                  <div style={s.ventasTopBar}>
                    <span style={s.seccionTitulo}>📊 VENTAS DESDE ÚLTIMA COMPRA</span>
                    <div style={s.ventasResumen}>
                      <span style={s.ventasBadge}>{productoDetalle.total_vendido.toFixed(0)} unidades</span>
                      <span style={{...s.ventasBadge, background: '#1a3a2a', color: '#4caf50'}}>${productoDetalle.total_revenue.toFixed(2)} revenue</span>
                    </div>
                  </div>
                  {productoDetalle.ventas.length === 0 ? (
                    <p style={{ color: '#555', fontSize: 13, padding: '16px 0' }}>Sin ventas desde la última compra</p>
                  ) : (
                    <div style={s.ventasTabla}>
                      <div style={s.ventasHeader}>
                        <span style={{ flex: 2 }}>Fecha</span>
                        <span style={{ flex: 4 }}>Cliente</span>
                        <span style={{ flex: 2 }}>Factura</span>
                        <span style={{ width: 60, textAlign: 'right' }}>Cant.</span>
                        <span style={{ width: 80, textAlign: 'right' }}>Precio</span>
                      </div>
                      <div style={s.ventasScroll}>
                        {productoDetalle.ventas.map((v, i) => (
                          <div key={i} style={{...s.ventasRow, background: i % 2 === 0 ? '#1a1a2e' : '#1e1e2e'}}>
                            <span style={{ flex: 2, color: '#aaa', fontSize: 12 }}>{v.fecha}</span>
                            <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{v.cliente}</span>
                            <span style={{ flex: 2, color: '#555', fontSize: 12 }}>{v.factura}</span>
                            <span style={{ width: 60, textAlign: 'right', color: '#fff', fontWeight: 'bold', fontSize: 13 }}>{v.cantidad.toFixed(0)}</span>
                            <span style={{ width: 80, textAlign: 'right', color: '#4cc9f0', fontSize: 13 }}>${v.precio.toFixed(2)}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}



const s = {
  cargando: { color: '#aaa', textAlign: 'center' },
  searchProducto: { background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '10px 14px', fontSize: 13, width: '100%', marginBottom: 16, boxSizing: 'border-box'},
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 },
  botonVer: { background: 'none', border: '1px solid #4cc9f0', borderRadius: 6, color: '#4cc9f0', padding: '4px 12px', cursor: 'pointer', fontSize: 12 },
  titulo: { color: '#fff', marginBottom: 4 },
  subtitulo: { color: '#555', fontSize: 13 },
  resultadosCliente: { background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, marginBottom: 16, overflow: 'hidden' },
  resultadoItem: { padding: '12px 16px', cursor: 'pointer', background: '#1a1a2e', borderBottom: '1px solid #2d2d44' },
  clienteHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 0', marginBottom: 12, borderBottom: '1px solid #2d2d44' },
  botonRefresh: { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', padding: '8px 16px', cursor: 'pointer', fontSize: 13 },
  kpisRow: { display: 'flex', gap: 12, marginBottom: 24, flexWrap: 'wrap' },
  kpiCard: { background: '#1e1e2e', borderRadius: 12, padding: 16, flex: 1, minWidth: 120, borderTop: '3px solid #7209b7' },
  kpiValor: { color: '#fff', fontSize: 26, fontWeight: 'bold', marginBottom: 4 },
  kpiLabel: { color: '#aaa', fontSize: 11 },
  tabs: { display: 'flex', gap: 4, borderBottom: '1px solid #2d2d44', marginBottom: 0 },
  tab: { background: 'none', border: 'none', borderBottom: '2px solid transparent', color: '#888', padding: '12px 20px', cursor: 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 },
  tabActivo: { color: '#fff', fontWeight: 'bold', borderBottomColor: '#e63946' },
  tabBadge: { background: '#e63946', color: '#fff', borderRadius: 10, padding: '2px 7px', fontSize: 11 },
  contenido: { background: '#1e1e2e', borderRadius: '0 0 12px 12px', padding: 24, minHeight: 300 },
  sinAlertas: { textAlign: 'center', padding: '60px 0' },
  tabla: { borderRadius: 8, overflow: 'hidden' },
  tablaHeader: { display: 'flex', padding: '10px 16px', background: '#0f0f1a', color: '#555', fontSize: 11, fontWeight: 'bold', gap: 8 },
  tablaRow: { display: 'flex', padding: '10px 16px', gap: 8, alignItems: 'center', transition: 'background 0.15s' },
  totalRow: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '16px 16px 0', borderTop: '1px solid #2d2d44', marginTop: 8 },
  muertoInfo: { marginBottom: 12 },
  buscadorRow: { display: 'flex', gap: 8, marginBottom: 16 },
  inputBusqueda: { flex: 1, background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '10px 14px', fontSize: 13 },
  botonBuscar: { background: '#1a2a3e', border: '1px solid #4cc9f0', borderRadius: 8, color: '#4cc9f0', padding: '10px 18px', cursor: 'pointer', fontWeight: 'bold', fontSize: 13 },
  botonLimpiar: { background: '#2d2d44', border: 'none', borderRadius: 8, color: '#aaa', padding: '10px 14px', cursor: 'pointer', fontSize: 13 },
  // Manual
  manualContainer: { display: 'flex', gap: 0, margin: '-24px', minHeight: 500 },
  manualSidebar: { width: 200, background: '#0f0f1a', borderRight: '1px solid #2d2d44', padding: 16, display: 'flex', flexDirection: 'column' },
  sidebarTitulo: { color: '#fff', fontWeight: 'bold', fontSize: 13, marginBottom: 10 },
  searchMarca: { background: '#1a1a2e', border: '1px solid #2d2d44', borderRadius: 6, color: '#fff', padding: '7px 10px', fontSize: 12, marginBottom: 8, width: '100%', boxSizing: 'border-box' },
  marcasList: { flex: 1, overflowY: 'auto', maxHeight: 'calc(100vh - 220px)' },
  marcaItem: { padding: '7px 10px', borderRadius: 6, cursor: 'pointer', color: '#888', fontSize: 12 },
  marcaItemActivo: { background: '#2d2d44', color: '#fff' },
  manualMain: { flex: 1, padding: 24, overflowY: 'auto' },
  manualHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8 },
  botonImprimir: { background: 'none', border: '1px solid #aaa', borderRadius: 8, color: '#aaa', padding: '8px 14px', cursor: 'pointer', fontSize: 13 },
  botonGuardar: { background: '#e63946', border: 'none', borderRadius: 8, color: '#fff', padding: '8px 16px', cursor: 'pointer', fontWeight: 'bold', fontSize: 13 },
  inputCantidad: { width: 75, background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 6, color: '#fff', padding: '5px 8px', fontSize: 14, textAlign: 'center' },
  // Modal
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.75)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 },
  modal: { background: '#1a1a2e', borderRadius: 16, border: '1px solid #2d2d44', width: '90%', maxWidth: 800, maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 28px', borderBottom: '1px solid #2d2d44', flexShrink: 0 },
  modalTitulo: { color: '#fff', fontSize: 15, fontWeight: 'bold', flex: 1, marginRight: 16 },
  modalCerrar: { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', fontSize: 16, cursor: 'pointer', padding: '6px 12px' },
  filaCompra: { borderBottom: '1px solid #2d2d44', padding: '20px 28px', flexShrink: 0 },
  filaCompraInner: { display: 'flex', gap: 32, alignItems: 'flex-start' },
  compraGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px 24px', flex: 1 },
  compraItem: { display: 'flex', flexDirection: 'column', gap: 2 },
  compraLabel: { color: '#555', fontSize: 11 },
  compraValor: { color: '#fff', fontSize: 13 },
  stockWrap: { minWidth: 200 },
  seccionTitulo: { color: '#4cc9f0', fontSize: 11, fontWeight: 'bold', letterSpacing: 1, marginBottom: 12 },
  stockRow: { display: 'flex', alignItems: 'center', gap: 12 },
  stockCard: { flex: 1, background: '#0f0f1a', borderRadius: 8, padding: '12px 8px', textAlign: 'center', border: '1px solid #2d2d44' },
  stockNum: { color: '#fff', fontSize: 24, fontWeight: 'bold' },
  stockLabel: { color: '#555', fontSize: 10, marginTop: 4 },
  stockArrow: { color: '#555', fontSize: 18 },
  filaVentas: { flex: 1, display: 'flex', flexDirection: 'column', padding: '20px 28px', overflow: 'hidden' },
  ventasTopBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8, flexShrink: 0 },
  ventasResumen: { display: 'flex', gap: 8 },
  ventasBadge: { background: '#1a2a3e', color: '#4cc9f0', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 'bold' },
  ventasTabla: { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', borderRadius: 8 },
  ventasHeader: { display: 'flex', padding: '8px 14px', background: '#0f0f1a', color: '#555', fontSize: 11, fontWeight: 'bold', gap: 8, flexShrink: 0 },
  ventasScroll: { overflowY: 'auto', flex: 1 },
  ventasRow: { display: 'flex', padding: '9px 14px', gap: 8, alignItems: 'center' },
};